'use strict';

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.config(function ($routeProvider) {

    $routeProvider
        .when('/communes', {
            topbarKey: "COMMUNES",
            controller: 'ObservatoireCommunesController',
            template: require("./communes.html")
        });

});

ngModule.controller('ObservatoireCommunesController', function ($scope, obsPresentationPopin, obsUtils) {

    $scope.observatoryConfig = {
        publicObs: true,
        resourceBaseUrl: "/rest/public/observatoire/commune"
    };

    $scope.communeParams = {
        observatoire: 'OBSERVATOIRE_DETTE_COMMUNE',
        zonage: 'DEPARTEMENT',
        datatype: 'ENCOURS_DETTE',
        parHabitant: true,
        representation: 'ABSOLU',
        unite: 'VALEUR',
        temporalite: 'INSTANTANE',
        anneeInstantane: obsUtils.getDerniereAnneeDispo(),
        anneeDebut: obsUtils.getDerniereAnneeDispo() - 1,
        anneeFin: obsUtils.getDerniereAnneeDispo(),
        populationMin: null,
        populationMax: null
    };

    obsPresentationPopin.openIfFirstTime();

});



// WEBPACK FOOTER //
// ./src/apps/observatoire/ng/communes/communes.js